import React, { type ReactNode } from 'react';
import { styled as styled2 } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import messages from '../messages.tsx';
import DndFields from './assets/drag-and-drop-fields.svg';

const EmptyStateNew = ({ children }: { children: ReactNode }) => {
	const { formatMessage } = useIntl();
	return (
		<Container>
			<EmptyStateIcon alt={formatMessage(messages.emptyStateAltText)} src={DndFields} />
			{children}
		</Container>
	);
};

export const EmptyState = EmptyStateNew;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled2.div({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'flexStart',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& > p': {
		textAlign: 'center',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const EmptyStateIcon = styled2.img({
	height: '110px',
	marginTop: token('space.500'),
});
